export const FeathersServerEvent = {
  IS_AUTHENTICATED: '--is-authenticated-event--',
  IS_CONNECTED: '--is-connected-event--',
  IS_INITIALIZED: '--is-initialized-event--',
  IS_READY: '--is-ready-event--',
}
